import CustomToast from "@/components/global/CustomToast.vue";
import HtmlToast from "@/components/global/HtmlToast.vue";

export default {
  data: () => ({
    mixinToastCount: 0,
  }),
  created: function () {},
  methods: {
    confirmDialog(
      title,
      contentHTML,
      onConfirm,
      onCancel = () => {},
      callback = () => {},
      config = {}
    ) {
      this.$store
        .dispatch("commonDialog", {
          show: true,
          contentHTML,
          title,
          onSubmit: onConfirm,
          onCancel,
          submitText: "Confirm",
          cancelText: "Cancel",
          hideOnCancel: true,
          width: "500px",
          ...config,
        })
        .then(() => {
          if (callback instanceof Function) callback();
        });
    },
    hideDialog(after) {
      this.$store.dispatch("commonDialog", { show: false, width: "30vw" }).then(() => {
        this.setDialogCancelOnLoading(false);
        this.setDialogLoading(false);
        if (after instanceof Function) after();
      });
    },
    setDialogLoading(mode = true, after = () => {}) {
      this.$store.dispatch("commonDialog", { loading: mode }).then(() => {
        if (after instanceof Function) after();
      });
    },
    setDialogCancelOnLoading(mode = true, after = () => {}) {
      this.$store.dispatch("commonDialog", { cancelLoading: mode }).then(() => {
        if (after instanceof Function) after();
      });
    },
    isSuccess(value) {
      return ["yes", "y", "done", "success", "ok", "true"].includes(value?.toLowerCase());
    },
    checkForError(response) {
      if (response?.actionResult?.toLowerCase() === "error") {
        if (response.exceptionId) {
          this.notifyWithInfo(
            "error",
            response?.actionMsg,
            "Exception Code : " + response?.exceptionId
          );
        }
        // else {
        //   this.notify(response?.actionMsg, "error");
        // }
        return true;
      }
      return false;
    },
    notify(text, type = "success", options = {}) {
      if (!type) {
        type = "success";
      }
      let _type = type?.toString()?.toLocaleLowerCase();
      if (["yes", "y", "done", "success", "ok", true, "true"].includes(_type)) {
        _type = "success";
      } else if (["info"].includes(_type)) {
        _type = "info";
      } else if (["no", "n", "cancel", "fail", "error", false, "false"].includes(_type)) {
        _type = "error";
      }
      if (_type === "error") {
        options.timeout = 10000;
        options.closeOnClick = false;
      }
      if (_type !== "error") {
        if (!window.mixinToastCount) window.mixinToastCount = 0;
        if (window.mixinToastCount > 3) {
          return;
        }
        window.mixinToastCount += 1;
        setTimeout(() => (window.mixinToastCount -= 1), 3000);
      }
      options.type = _type;
      const isHtml = text?.toString()?.includes("</a>");

      if (typeof text === "string") {
        if (isHtml) {
          const content = {
            component: HtmlToast,
            props: {
              html: text,
            },
          };
          this.$toast(content, { ...options, timeout: 10000, closeOnClick: false });
          return;
        }
        this.$toast(text, options);
      } else {
        options.type = "error";
        if (text instanceof Object) {
          text = JSON.stringify(text);
        } else {
          text = text?.toString() || "";
        }
        if (text) {
          this.$toast(text, options);
        }
        // console.warn("Message type is not string :\n", type.toString());
      }
    },
    notifyWithInfo(_type = "N", text = "", info = "", html = "", onClick = () => {}) {
      if (["yes", "y", "done", "success", "ok", true, "true"].includes(_type)) {
        _type = "success";
      } else if (["info"].includes(_type)) {
        _type = "info";
      } else if (["no", "n", "cancel", "fail", "error", false, "false"].includes(_type)) {
        _type = "error";
      }
      const content = {
        component: CustomToast,
        props: {
          text,
          info,
          html,
          type: _type,
        },
        listeners: {
          click: () => onClick,
        },
      };
      this.$toast(content, { timeout: 10000, closeOnClick: false, type: _type });
    },
  },
};
